import { useCallback, useState } from 'react';
export const useCarousel = (props) => {
    var _a;
    const pages = props.dataSource;
    const [index, setIndex] = useState((_a = props.defaultIndex) !== null && _a !== void 0 ? _a : 0);
    const bind = () => {
        return {
            dataSource: props.dataSource,
            index,
        };
    };
    const handleGoto = useCallback((dir) => {
        setIndex((prev) => {
            const next = prev + dir;
            return Math.max(Math.min(next !== null && next !== void 0 ? next : 0, pages.length - 1), 0);
        });
    }, []);
    return {
        handleGoto,
        bind,
    };
};
